import { render, staticRenderFns } from "./CardCustomer.vue?vue&type=template&id=47c9469e&scoped=true"
import script from "./CardCustomer.vue?vue&type=script&lang=js"
export * from "./CardCustomer.vue?vue&type=script&lang=js"
import style0 from "./CardCustomer.vue?vue&type=style&index=0&id=47c9469e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c9469e",
  null
  
)

export default component.exports